export const LANGUAGES = [
  "en",
  "de",
  "es",
  "es-lm",
  "fr-ca",
  "fr-fr",
  "fr-eu",
  "it",
  "pt-br",
  "zh-cn",
  "zh-tw",
  "ja",
  "ko",
] as const;

const LANGUAGE_KEYS = new Set<string>(LANGUAGES);

export type KazooLanguage = (typeof LANGUAGES)[number];

export const languagesMap: Record<KazooLanguage, string> = {
  en: "content:languages.english",
  de: "content:languages.german",
  es: "content:languages.spanish",
  "es-lm": "content:languages.spanish",
  "fr-ca": "content:languages.canadianFrench",
  "fr-fr": "content:languages.europeanFrench",
  "fr-eu": "content:languages.europeanFrench",
  it: "content:languages.italian",
  "pt-br": "content:languages.brazilPortuguese",
  "zh-cn": "content:languages.simplifiedChinese",
  "zh-tw": "content:languages.chineseTraditional",
  ja: "content:languages.japanese",
  ko: "content:languages.korean",
};

function isValidLanguage(language?: string): language is KazooLanguage {
  if (!language) {
    return false;
  }

  return LANGUAGE_KEYS.has(language.toLowerCase());
}

export function getLanguageOrFallback(language?: string): KazooLanguage {
  const lowerCaseLanguage = language?.toLowerCase();
  if (isValidLanguage(lowerCaseLanguage)) {
    return lowerCaseLanguage;
  }

  return "en";
}
